// frontend/src/components/Layout.js
import React from "react";
import "./layout.css";

function Layout({
  children,
  title = "مؤسسه علمی و آموزشی الف مشاور",
  subtitle = "سامانه مدیریت آموزشی و مشاوره‌ای",
  className = "",
  cardClassName = "",
}) {
  return (
    <div className={`auth-wrapper ${className}`.trim()}>
      <header className="auth-header">
        <img src="/logo2.png" alt="لوگو" className="auth-logo" />
        <h2 className="auth-title">{title}</h2>
        <p className="auth-subtitle">{subtitle}</p>
      </header>

      <main className={`auth-card glass-card ${cardClassName}`.trim()}>
        {children}
      </main>
    </div>
  );
}

export default Layout;
